<script setup>

// AddButtonは状態を知らない。あくまでイベントを渡すだけ。
const objectOfAttrs = {
    id: 'add-button',
    type: 'button'
}
defineProps({
    label: {
        type: String,
        default: '追加'
    }
});

//クリックイベントを親に通知する
const emit = defineEmits(['add']);
</script>

<template>
    <button v-bind="objectOfAttrs" @click="emit('add')" class="
    bg-emerald-500 
    p-4 text-white rounded-md
    cursor-pointer
    hover:bg-emerald-600 focus:outline-offset-2 focus:outline-4 focus:outline-emerald-400
    active:bg-emerald-600">
        {{ label }}
    </button>
</template>